"use strict";
var aCallable = require("../internals/a-callable");
var isNullOrUndefined = require("../internals/is-null-or-undefined");
module.exports = function(V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? void 0 : aCallable(func);
};
